import { ColorTheme } from '@/stores/themeStore.ts';

export const getSavedTheme = (): string | undefined => {
    return localStorage.getItem('mantine-color-scheme-value') ?? undefined;
};

export const toggleTailwindTheme = (color_theme: ColorTheme): void => {
    const html_element = document.documentElement;
    // eslint-disable-next-line unicorn/prefer-classlist-toggle
    if (color_theme === ColorTheme.LIGHT) {
        html_element.classList.remove('dark');
    } else {
        html_element.classList.add('dark');
    }
};
